export default function Contact() {
  return (
    <section id="contact" className="pt-24 p-12 text-center bg-gray-100 ">
      <h2  className="text-3xl font-bold mb-6">Contact Us</h2>

      <div className="space-y-4 text-lg">
        <h1 style={{color:"#B8860B"}} ><strong>HUNTERS CRICKET ACADEMY</strong></h1>
        <p>
          📍 <strong>Branch:</strong> VANAGARAM,LOYOLA COLLEGE, MYLAPORE.
        </p>

        <p>
          📞 <strong>Phone:</strong> +91 9790 964195
        </p>
      </div>
    </section>
  );
}
